(function(){
  var bar,pe,sBtn,scheduled=false;
  function scope(){ return document.querySelector('.product-information'); }
  function q(sel){ var s=scope(); return s?s.querySelector(sel):null; }
  function readPrice(){
    var priceSrc=q('product-price'); if(!priceSrc)return '';
    var b2b=priceSrc.querySelector('.b2b-amount'); if(b2b&&b2b.textContent.trim())return b2b.textContent.trim();
    var c=priceSrc.cloneNode(true);
    c.querySelectorAll('s,del,[class*=compare],.visually-hidden,.vat-included-note,.tax-note,.installments,.payment-terms,form').forEach(function(n){n.remove();});
    return (c.textContent||'').replace(/PDV[\s\S]*$/i,'').replace(/\s+/g,' ').trim();
  }
  function isSoldOut(){
    var b=q('button[name=add]'); if(!b)return false; if(b.disabled)return true;
    var l=b.querySelector('.add-to-cart-text__content');
    var t=(l?l.textContent:b.textContent).trim().toLowerCase();
    return /rasprodano|sold ?out|nedostupno|nema na/.test(t);
  }
  function applySoldOut(){
    var b=q('button[name=add]'); var so=isSoldOut();
    if(b){ b.classList.toggle('mojspa-soldout',so); if(so){ if(b.getAttribute('aria-disabled')!=='true')b.setAttribute('aria-disabled','true'); } else { if(b.hasAttribute('aria-disabled'))b.removeAttribute('aria-disabled'); } }
    if(sBtn){ sBtn.classList.toggle('mojspa-soldout',so); var want=so?'Rasprodano':'Dodaj u košaricu'; if(sBtn.textContent.trim()!==want)sBtn.textContent=want; }
  }
  function update(){
    if(!bar)return; var s=scope(); var t=s&&(s.querySelector('.buy-buttons-block')||s.querySelector('button[name=add]'));
    if(!t){bar.classList.remove('is-visible');return;}
    var r=t.getBoundingClientRect(); var inView=r.top<(window.innerHeight-20)&&r.bottom>0;
    bar.classList.toggle('is-visible',!inView);
  }
  function refresh(){
    var s=scope();
    if(!s||!s.querySelector('button[name=add]')){ if(bar)bar.classList.remove('is-visible'); return; }
    if(!bar){
      bar=document.createElement('div'); bar.id='mojspaStickyAtc'; bar.className='mojspa-sticky-atc';
      bar.innerHTML="<span class='mojspa-sticky-atc__price'></span><button type='button' class='mojspa-sticky-atc__btn'>Dodaj u košaricu</button>";
      document.body.appendChild(bar);
      pe=bar.querySelector('.mojspa-sticky-atc__price'); sBtn=bar.querySelector('.mojspa-sticky-atc__btn');
      sBtn.addEventListener('click',function(){ if(sBtn.classList.contains('mojspa-soldout'))return; var b=q('button[name=add]'); if(b)b.click(); });
      window.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update);
    }
    var p=readPrice(); if(p&&pe.textContent!==p)pe.textContent=p;
    applySoldOut(); update();
  }
  function schedule(){ if(scheduled)return; scheduled=true; requestAnimationFrame(function(){ scheduled=false; refresh(); }); }
  function boot(){ refresh(); setTimeout(refresh,400); setTimeout(refresh,1000); }
  if(document.readyState!=='loading')boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
  if(window.MutationObserver){
    var mo=new MutationObserver(schedule);
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
